module.exports = {
  content: {
    'zh-CN': '上海萌果信息科技有限公司（萌果游戏）成立于2012年，专注于互联网移动游戏的<br>研发和发行。发展至今近130人，公司业务从手机游戏开始延伸至H5游戏、VR游戏、海外<br>游戏代理发行等，旗下的EnjoyGame（英卓游戏）成立于2015年，专注致力于将中国精品手游发<br>行到海外全球市场。团队40余人，核心成员均有8年以上海外发行经验，以专业的快速发展，以实力打<br>造更优质精品，形成了独有的行业品牌和口碑。发行范围覆盖全球。公司致力于成为"最好的移动网络游戏制造、发行商"，将为全球的移动互联网用户提供一个更自由、更宽广、更娱乐的游戏世界！接下来萌果还将陆续推出更多不同主题、不同类型的移动互联网产品，给大家带来更优质的游戏体验！',
    'en-US': '',
    'th-TH': ''
  },
  developCooperation: {
    'zh-CN': '研发合作',
	'zh-TW': '',
    'en-US': '',
    'th-TH': ''
  },
  issueCooperation: {
    'zh-CN': '发行合作',
	'zh-TW': '',
    'en-US': '',
    'th-TH': ''
  },
  hr: {
    'zh-CN': '求职需求',
    'zh-TW': '',
    'en-US': '',
    'th-TH': ''
  },
  haveGoodProduction: {
    'zh-CN': '有好的游戏产品？',
    'zh-TW': '有好的遊戲產品？',
    'en-US': 'Have good production?',
    'th-TH': 'Have good production?'
  },
  goToSubmit: {
    'zh-CN': '前往提交',
	'zh-TW': '前往提交',
    'en-US': 'Submit',
    'th-TH': 'Submit'
  }
};



// WEBPACK FOOTER //
// ./src/lang/business.js